import { render, staticRenderFns } from "./AccountOrdersV2.vue?vue&type=template&id=5755244f&scoped=true&"
import script from "./AccountOrdersV2.vue?vue&type=script&lang=js&"
export * from "./AccountOrdersV2.vue?vue&type=script&lang=js&"
import style0 from "./AccountOrdersV2.vue?vue&type=style&index=0&id=5755244f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5755244f",
  null
  
)

export default component.exports